/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:26da02f6-e0fa-4963-ad3e-b627adbb8238",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_xPPFUxEa2",
    "aws_user_pools_web_client_id": "2bk7ijq8lktn39mkv63li378l2",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://zsw3zbonqfcqjmft4ln6bkalqa.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-iuekc46k4vbqjjali76yaqhgyq",
    "aws_user_files_s3_bucket": "s3omsagtoolswebmasterreports163144-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
